import { DataTable } from "../components/DataTable";
import { StatusPill } from "../components/StatusPill";
import { formatRelative } from "../lib/format";
import type { Tone } from "../lib/status";
import { fetchDashboardTenant } from "../lib/dashboard";
import { DashboardStateView, useDashboardQuery } from "../hooks/useDashboardQuery";

function toneFor(live: boolean, mode: string): Tone {
  if (live) return "warn";
  if (mode === "simulation") return "ok";
  return "neutral";
}

export function TenantsPage() {
  const state = useDashboardQuery(fetchDashboardTenant);

  return (
    <>
      <div className="page-header">
        <div>
          <h1>Tenants</h1>
          <p>Current authenticated tenant only. Cross-tenant rosters are not exposed.</p>
        </div>
        <StatusPill label="Read-only" tone="neutral" />
      </div>
      <DashboardStateView
        state={state}
        emptyTitle="Tenant not found"
        emptyDetail="No tenant configuration is available for this session."
      >
        {(data) => (
          <div className="panel">
            <div className="panel-body" style={{ paddingTop: 0 }}>
              <DataTable
                rows={[data.tenant]}
                rowKey={(r) => r.slug}
                columns={[
                  { key: "tenant", header: "Tenant", render: (r) => r.name },
                  {
                    key: "slug",
                    header: "Slug",
                    render: (r) => <span className="mono">{r.slug}</span>,
                  },
                  {
                    key: "mode",
                    header: "Execution mode",
                    render: (r) => <span className="mono">{r.executionMode}</span>,
                  },
                  {
                    key: "bridge",
                    header: "Bridge",
                    render: (r) => r.bridgeMode,
                  },
                  {
                    key: "status",
                    header: "Live execution",
                    render: (r) => (
                      <StatusPill
                        label={r.liveExecutionEnabled ? "Enabled" : "Disabled"}
                        tone={toneFor(r.liveExecutionEnabled, r.executionMode)}
                      />
                    ),
                  },
                  {
                    key: "keys",
                    header: "Active API keys",
                    render: (r) => String(r.activeApiKeyCount),
                  },
                  {
                    key: "kill",
                    header: "Kill switch",
                    render: (r) => (r.killSwitchActive ? "Active" : "Inactive"),
                  },
                  {
                    key: "updated",
                    header: "Updated",
                    render: (r) => formatRelative(r.updatedAt),
                  },
                ]}
              />
            </div>
          </div>
        )}
      </DashboardStateView>
    </>
  );
}
